import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import {
  ReactSelectCodeAPE,
  ReactSelectCompanies,
  ReactSelectCountries,
  ReactSelectCurrency,
  ReactSelectCustomizableAttributesAsync,
  ReactSelectDegrees,
  ReactSelectFieldOfStudies,
  ReactSelectIndustries,
  ReactSelectJobFunctions,
  ReactSelectMemberships,
  ReactSelectNationalities,
  ReactSelectPromoCode,
  ReactSelectRoles,
  ReactSelectSchools,
  ReactSelectSearchAndOptions,
  ReactSelectSkills,
  ReactSelectSubnetworks,
  ReactSelectTimezones,
  ReactSelectTopics,
  ReactSelectUserCustomizableAttributes,
  ReactSelectUsers,
} from 'hb-react/shared/components/ReactSelect';
import ReactSelectMentoringProfile from 'hb-react/shared/components/ReactSelect/ReactSelectMentoringProfile';

const getSelectComponent = (type) => {
  switch (type) {
    case 'countries':
      return ReactSelectCountries;

    case 'timezone':
      return ReactSelectTimezones;

    case 'industries':
      return ReactSelectIndustries;

    case 'companies':
      return ReactSelectCompanies;

    case 'currencies':
      return ReactSelectCurrency;

    case 'job_functions':
      return ReactSelectJobFunctions;

    case 'skills':
      return ReactSelectSkills;

    case 'users':
      return ReactSelectUsers;

    case 'mentors':
    case 'mentees':
      return ReactSelectMentoringProfile;

    case 'nationalities':
      return ReactSelectNationalities;

    case 'sub_networks':
      return ReactSelectSubnetworks;

    case 'roles':
      return ReactSelectRoles;

    case 'memberships':
      return ReactSelectMemberships;

    case 'schools':
      return ReactSelectSchools;

    case 'field_of_studies':
      return ReactSelectFieldOfStudies;

    case 'degrees':
      return ReactSelectDegrees;

    case 'codeAPE':
      return ReactSelectCodeAPE;

    case 'customizable_attribute_select_async':
      return ReactSelectCustomizableAttributesAsync;

    case 'user_customizable_attributes':
      return ReactSelectUserCustomizableAttributes;

    case 'search_and_options':
      return ReactSelectSearchAndOptions;

    case 'topics':
      return ReactSelectTopics;

    case 'promo_codes':
      return ReactSelectPromoCode;

    case 'default':
    default:
      return ReactSelectInput;
  }
};

export default getSelectComponent;
